import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import BalanceInputs from '../../NestedInputs/BalanceInputs';

export default function SummaryDiscounts({ discounts, dispatch, viewOnly }) {
  const { values, errors } = useFormikContext();
  return (
    <>
      <Row className="summary__balances_header">
        <Col md={6} className="">
          <strong>Descuentos</strong>
        </Col>
        <Col className="col-1 " />
        <Col md={4} className="">
          <strong>Monto</strong>
        </Col>
      </Row>
      <Row>
        <Col xl={12} xs={12} md={12} lg={12} style={{ textAlign: 'center' }}>
          <BalanceInputs
            isVariable={false}
            variable="settlement"
            subVariable="settlementBalancesAttributes"
            balanceType="discount"
            dispatch={dispatch}
            discounts={discounts}
            allValuesAttributes={values?.settlement?.settlementBalancesAttributes}
            canCreate={!viewOnly}
            canDestroy={!viewOnly}
            createOnClick={!viewOnly}
          />
        </Col>
      </Row>
      <Row>
        <Col xl={12} xs={12} md={12} lg={12} style={{ textAlign: 'center' }}>
          {errors.settlement?.settlementBalancesAttributes && (
            <Col xl={12} xs={12} md={12} lg={12} style={{ marginBottom: 10, textAlign: 'center' }}>
              {typeof errors.settlement?.settlementBalancesAttributes === 'string' && (
                <Form.Text className="text-danger">
                  <strong>{errors.settlement.settlementBalancesAttributes}</strong>
                </Form.Text>
              )}
            </Col>
          )}
        </Col>
      </Row>
      <hr className="mb-2 mt-2 hr-summary-index" />
    </>
  );
}
